const TimeZones = [
  { name: '(UTC-12:00) International Date Line West', id: '-12:00' },
  { name: '(UTC-11:00) Midway Island, Samoa', id: '-11:00' },
  { name: '(UTC-10:00) Hawaii', id: '-10:00' },
  { name: '(UTC-09:00) Alaska', id: '-09:00' },
  { name: '(UTC-08:00) Pacific Time (US and Canada)', id: '-08:00' },
  { name: '(UTC-07:00) Mountain Time (US and Canada)', id: '-07:00' },
  { name: '(UTC-06:00) Central Time (US and Canada)', id: '-06:00' },
  { name: '(UTC-05:00) Eastern Time (US and Canada)', id: '-05:00' },
  { name: '(UTC-04:00) Atlantic Time (Canada)', id: '-04:00' },
  { name: '(UTC-03:30) Newfoundland and Labrador', id: '-03:30' },
  { name: '(UTC-03:00) Brasilia, Buenos Aires, Greenland', id: '-03:00' },
  { name: '(UTC-02:00) Mid-Atlantic', id: '-02:00' },
  { name: '(UTC-01:00) Azores, Cape Verde Islands', id: '-01:00' },
  { name: '(UTC) Coordinated Universal Time; GMT Standard Time', id: '+00:00' },
  { name: '(UTC+01:00) Central European Standard Time', id: '+01:00' },
  { name: '(UTC+02:00) Eastern European Standard Time', id: '+02:00' },
  { name: '(UTC+03:00) Moscow, Kuwait, Nairobi, Baghdad', id: '+03:00' },
  { name: '(UTC+03:30) Tehran', id: '+03:30' },
  { name: '(UTC+04:00) Abu Dhabi, Tbilisi', id: '+04:00' },
  { name: '(UTC+04:30) Kabul', id: '+04:30' },
  { name: '(UTC+05:00) Ekaterinburg, Islamabad, Tashkent', id: '+05:00' },
  { name: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', id: '+05:30' },
  { name: '(UTC+05:45) Kathmandu', id: '+05:45' },
  { name: '(UTC+06:00) Astana, Dhaka, Novosibirsk', id: '+06:00' },
  { name: '(UTC+06:30) Yangon Rangoon', id: '+06:30' },
  { name: '(UTC+07:00) Bangkok, Jakarta, Krasnoyarsk', id: '+07:00' },
  { name: '(UTC+08:00) Beijing, Hong Kong, Singapore, Perth', id: '+08:00' },
  { name: '(UTC+09:00) Seoul, Tokyo, Yakutsk', id: '+09:00' },
  { name: '((UTC+09:30) Darwin, Adelaide', id: '+09:30' },
  { name: '(UTC+10:00) Sydney, Vladivostok, Port Moresby', id: '+10:00' },
  { name: '(UTC+11:00) Magadan, Solomon Islands, New Caledonia', id: '+11:00' },
  { name: '(UTC+12:00) Fiji Islands, Auckland, Wellington', id: '+12:00' },
  { name: "(UTC+13:00) Nuku'alofa", id: '+13:00' }
];

export { TimeZones };
